import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { dismissPresenceNotificationAction } from 'store/presence/actions';
import { selectPresenceNotifications } from 'store/presence/selectors';

import { PRESENCE_TOAST_AUTO_DISMISS_MS } from '../PresenceToast.constants';

const usePresenceToast = () => {
  const dispatch = useDispatch();

  const notifications = useSelector(selectPresenceNotifications);

  const timersRef = useRef({});

  const dismissNotification = useCallback(
    id => {
      dispatch(dismissPresenceNotificationAction(id));

      if (timersRef.current[id]) {
        clearTimeout(timersRef.current[id]);
        delete timersRef.current[id];
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const timers = timersRef.current;

    notifications.forEach(({ id }) => {
      if (!timers[id]) {
        timers[id] = setTimeout(() => {
          dismissNotification(id);
        }, PRESENCE_TOAST_AUTO_DISMISS_MS);
      }
    });
  }, [notifications, dismissNotification]);

  useEffect(() => {
    const timers = timersRef.current;

    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, []);

  return { notifications, dismissNotification };
};

export default usePresenceToast;
